'use strict';

require('vocabs')(
  exports,
  'http://www.w3.org/2000/01/rdf-schema#', 'rdfs',
  ['subClassOf', 'subPropertyOf']
);
